module.exports = __webpack_public_path__ + "static/img/punball_small_1.8ee2fb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ja/punball_small_1.jpg
// module id = wMKE
// module chunks = 0